import React from 'react';

import cn from 'classnames';

import { Flex } from '@shared/ui';

import cls from './MessagesList.module.css';

interface IMessagesListProps {
    children: React.ReactNode;
    className?: string;
}

export const MessagesList = React.forwardRef<HTMLUListElement, IMessagesListProps>(
    ({ className, children }, ref) => (
        <Flex
            ref={ref as React.Ref<HTMLElement>}
            as="ul"
            direction="column"
            gap={12}
            className={cn(cls.MessagesList, className)}
            fullWidth
        >
            {children}
        </Flex>
    )
);

MessagesList.displayName = 'MessagesList';
